import { render, staticRenderFns } from "./TagsComponent.vue?vue&type=template&id=1d3e2993&scoped=true"
import script from "./TagsComponent.vue?vue&type=script&lang=js"
export * from "./TagsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3e2993",
  null
  
)

export default component.exports